export const allTimezones = [
  'America/Los_Angeles', // Pacific Time (California, Washington, Oregon)
  'Pacific/Honolulu', // Hawaii
  'America/Anchorage', // Alaska
  'America/Juneau', // Alaska (Juneau)
  'America/Sitka', // Alaska (Sitka)
  'America/Adak', // Aleutian Islands
  'America/Metlakatla', // Metlakatla (Alaska, special rules)
  'America/Vancouver', // Pacific Time (Canada) (optional, if needed)
  'America/Tijuana', // Pacific Time (Mexico) (optional)
  'America/Phoenix', // Arizona (no DST)
  'America/Denver', // Mountain Time
  'America/Boise', // Mountain Time (Boise, Idaho)
  'America/Chicago', // Central Time
  'America/Indiana/Indianapolis', // Indiana (Indianapolis - no DST historically)
  'America/Detroit', // Eastern Time (Michigan)
  'America/New_York', // Eastern Time (New York, etc.)
  'America/Kentucky/Louisville', // Eastern Time (Louisville, Kentucky)
  'America/Puerto_Rico', // Atlantic Standard Time (no DST)
  'Pacific/Guam', // Guam (Chamorro Standard Time)
  'Pacific/Samoa', // American Samoa (Samoa Standard Time)
  'Europe/London',
  'Europe/Berlin',
  'Europe/Paris',
  'Europe/Rome',
  'Europe/Madrid',
  'Europe/Moscow',
  'Asia/Dubai',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Dhaka',
  'Asia/Bangkok',
  'Asia/Hong_Kong',
  'Asia/Tokyo',
  'Asia/Seoul',
  'Australia/Sydney',
  'Pacific/Auckland',
];
